
import { createContext, useState } from 'react'

const PeriodsCtx = createContext({
  periodsList: [],
})

export default PeriodsCtx
